export const IS_LOADING_FEEDBACK = "IS_LOADING_FEEDBACK";
export const FEEDBACK_SUCCESS = "FEEDBACK_SUCCESS";
export const FEEDBACK_FAILED = "FEEDBACK_FAILED";